import { Keyboard } from "lucide-react";
import { createFileRoute } from "@tanstack/react-router";
import { msg } from "@lingui/core/macro";
import { Trans, useLingui } from "@lingui/react/macro";

import { CompanionHero, SurfaceHeader, SurfaceLayout } from "@ando/ui";

import { ShortcutsList } from "@/features/help";

/**
 * ``/settings/shortcuts`` — full-page mirror of the ⌘/ overlay.
 *
 * Uses the same ``<ShortcutsList />`` body so there's exactly ONE source
 * of truth for the catalogue + filter behaviour. Useful when a user
 * lands here via the avatar drawer's "Tasti rapidi" row (closing the
 * drawer would normally pop the overlay — but the full-page surface is
 * also reachable via direct link and from the "Apri pagina completa"
 * affordance in the overlay footer).
 */
function ShortcutsSettingsPage() {
  const { i18n } = useLingui();
  return (
    <SurfaceLayout
      header={
        <SurfaceHeader
          label={i18n._(msg`Aiuto`)}
          title={i18n._(msg`Tasti rapidi`)}
          meta={
            <span>
              <Trans>
                <strong>20+</strong> scorciatoie · cerca per azione o tasto
              </Trans>
            </span>
          }
        />
      }
      hero={
        <CompanionHero icon={<Keyboard size={14} strokeWidth={2} />}>
          <Trans>
            Premi <strong>⌘ /</strong> in qualsiasi punto dell'app per aprire
            questa lista in un overlay senza lasciare il flusso.
          </Trans>
        </CompanionHero>
      }
    >
      <div className="pt-2">
        <ShortcutsList />
      </div>
    </SurfaceLayout>
  );
}

export const Route = createFileRoute("/_authed/_modal/settings/shortcuts")({
  component: ShortcutsSettingsPage,
});
